import React from "react";

const CoveredSurfaceIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 21.325v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6m-10-9H3l9-9 9 9h-2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
    ></path>
  </svg>
);

export default CoveredSurfaceIcon;
